import React from "react";
import { tierForElo } from "@/skate/lib/rank";

export const RankBadge = ({ elo = 1000, size = "md", showElo = false }) => {
  const tier = tierForElo(elo);
  const sizes = {
    xs: "w-8 h-8 text-[8px]",
    sm: "w-12 h-12 text-[10px]",
    md: "w-16 h-16 text-xs",
    lg: "w-24 h-24 text-sm",
    xl: "w-32 h-32 text-base",
  };
  return (
    <div className="inline-flex flex-col items-center gap-1" data-testid="rank-badge">
      <div
        className={`${sizes[size]} ${tier.className} relative flex items-center justify-center border-2 font-display tracking-widest`}
        style={{
          borderColor: tier.color,
          background: `radial-gradient(circle at 30% 20%, ${tier.color}22, transparent 70%), #0F0F10`,
        }}
      >
        <span style={{ color: tier.color }}>{tier.name}</span>
        <div className="absolute -inset-px border" style={{ borderColor: `${tier.color}33` }} />
      </div>
      {showElo && (
        <div className="font-mono text-xs text-zinc-400" data-testid="rank-elo">{elo} <span className="text-zinc-600">ELO</span></div>
      )}
    </div>
  );
};

export default RankBadge;
